import flatBuildOrdersControls from '@apphiveio/controlsmanager/functions/flatters/flatBuildOrdersControls'
// THIS VALUES ARE USED DURING CLIENT APP COMPILATION, PLEASE DO NOT MOVE
const initialAppId = 'app_j4rQuLb3KKxoiV9mR1LsYQ'
const initialProjectId = 'proj_e5kAs2Xz5R'
const initialBuildOrdersOnApp = require('./buildOrders.loaded.json') // eslint-disable-line
const initialRunningMode = 'premium'
const initialCustomFontName = undefined
// #################

export const initialAppState = {
    appId: initialAppId,
    projectId: initialProjectId,
    buildOrders: initialBuildOrdersOnApp,
    runningMode: initialRunningMode,
    customFontName: initialCustomFontName,
} as const
